import { render, staticRenderFns } from "./GetPicture.vue?vue&type=template&id=275454bc"
import script from "./GetPicture.vue?vue&type=script&lang=js"
export * from "./GetPicture.vue?vue&type=script&lang=js"
import style0 from "./GetPicture.vue?vue&type=style&index=0&id=275454bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports